import { translateText } from "../../i18n/translate-text.js";
import { seekedToText } from "../../../i18n/text/status.js";
import { valueText } from "../../../i18n/text/volume.js";
import { DEFAULT_INPUT_INDICATOR_LABELS, createInputIndicatorLabels } from "../indicator/labels.js";
import { rateText } from "../../../i18n/text/playback.js";
import { DEFAULT_LOCALE } from "@videojs/utils/i18n";
import { formatTimeAsPhrase } from "@videojs/utils/time";
//#region src/core/ui/status-announcer/labels.ts
/** Default English labels used when no translated labels are provided. */
const DEFAULT_STATUS_ANNOUNCER_LABELS = {
	...DEFAULT_INPUT_INDICATOR_LABELS,
	volumeWithValue: (value) => translateText(valueText, { value }),
	seekedTo: (time) => translateText(seekedToText, { time: formatTimeAsPhrase(time) }),
	playbackRate: (rate) => translateText(rateText, { rate })
};
/** Creates translated labels for status, volume, seek, and playback-rate announcements. */
function createStatusAnnouncerLabels(translator, locale = DEFAULT_LOCALE) {
	return {
		...createInputIndicatorLabels(translator),
		volumeWithValue: (value) => translator(valueText, { value }),
		seekedTo: (time) => translator(seekedToText, { time: formatTimeAsPhrase(time, { locale }) }),
		playbackRate: (rate) => translator(rateText, { rate })
	};
}
//#endregion
export { DEFAULT_STATUS_ANNOUNCER_LABELS, createStatusAnnouncerLabels };

//# sourceMappingURL=labels.js.map